import { render, staticRenderFns } from "./Oeffnungszeiten.vue?vue&type=template&id=db79fb32&scoped=true"
import script from "./Oeffnungszeiten.vue?vue&type=script&lang=js"
export * from "./Oeffnungszeiten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db79fb32",
  null
  
)

export default component.exports